var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAttentionDisable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon_attention_disable_svg__st0",
    fill: "none",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "icon_attention_disable_svg__st1",
    d: "M29.82 25.94L17.25 3.72C16.99 3.27 16.52 3 16 3s-.99.27-1.25.72L2.18 25.94c-.24.44-.23.97.03 1.39.26.43.72.68 1.22.67h25.14c.5.01.96-.24 1.22-.67.26-.43.27-.96.03-1.39zM4.44 26L16 5.57 27.56 26H4.44z",
    fill: props.color,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon_attention_disable_svg__st1",
    fill: props.color,
    fillRule: "evenodd",
    d: "M14.5 10h3v9h-3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "icon_attention_disable_svg__st1",
    cx: 16,
    cy: 23,
    r: 2,
    fill: props.color,
    fillRule: "evenodd"
  }));
}

export default SvgIconAttentionDisable;